var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeylimeBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_83588",
    "data-name": "Group 83588",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 149.402,
    height: 100.815,
    viewBox: "0 0 149.402 100.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57234",
    "data-name": "Rectangle 57234",
    width: 149.402,
    height: 100.815
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_78065",
    "data-name": "Group 78065",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107978",
    "data-name": "Path 107978",
    d: "M45.387,20.388a3.727,3.727,0,1,1,7.449,0,3.727,3.727,0,1,1-7.449,0",
    transform: "translate(23.107 8.418)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107979",
    "data-name": "Path 107979",
    d: "M36.594,20.388a3.727,3.727,0,1,1,7.449,0,3.727,3.727,0,1,1-7.449,0",
    transform: "translate(18.631 8.418)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107980",
    "data-name": "Path 107980",
    d: "M27.8,20.388a3.727,3.727,0,1,1,7.449,0,3.727,3.727,0,1,1-7.449,0",
    transform: "translate(14.153 8.418)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107981",
    "data-name": "Path 107981",
    d: "M3.424,42.239V54.1a6.679,6.679,0,0,1,6.207-3.426c3.211,0,6.722,1.755,6.722,7.663V71.05H12.927V58.892c0-3.382-1.413-5.265-4.324-5.265-3.595,0-5.179,2.354-5.179,6.506V71.007H0V42.153H3.424Z",
    transform: "translate(0 21.461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107982",
    "data-name": "Path 107982",
    d: "M16.361,58.886c.042,4.066,2.054,6.934,5.436,6.934,3.168,0,4.152-1.627,4.794-3.082h3.466c-.77,2.569-2.911,5.95-8.391,5.95-6.249,0-8.816-5.095-8.816-10.232,0-5.908,3-10.659,9.031-10.659,6.421,0,8.519,5.137,8.519,9.417,0,.6,0,1.114-.042,1.671Zm10.617-2.4c-.044-3.3-1.671-5.908-5.1-5.908-3.51,0-5.051,2.44-5.392,5.908Z",
    transform: "translate(6.543 24.335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107983",
    "data-name": "Path 107983",
    d: "M29.226,48.139C32.438,57.686,34.193,62.951,34.748,65h.044c.641-2.268,2.054-6.806,5.308-16.866h3.468L36.419,68.987c-2.013,5.822-3.51,7.319-7.621,7.319a19.585,19.585,0,0,1-2.14-.128v-3a10.219,10.219,0,0,0,1.627.085c2.526,0,3.468-1.112,4.666-4.452L25.5,48.139Z",
    transform: "translate(12.983 24.508)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107984",
    "data-name": "Path 107984",
    d: "M47.683,42.664V65.009h11.3v5.822H40.877V42.664Z",
    transform: "translate(20.811 21.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107985",
    "data-name": "Path 107985",
    d: "M69.3,71.309H62.152L66.69,41.727,78.675,58.9,90.706,41.727l4.536,29.582H88.093L86.424,56.926,78.719,68.655,71.013,56.926Z",
    transform: "translate(31.642 21.244)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107986",
    "data-name": "Path 107986",
    d: "M105.311,48.271V42.664H86.6V70.831h18.707V65.267H93.154V58.76H104.54V53.28H93.154V48.271Z",
    transform: "translate(44.092 21.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107987",
    "data-name": "Path 107987",
    d: "M55.174,67.178h6.934V49.841l-6.934,3.9Z",
    transform: "translate(28.09 25.375)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107988",
    "data-name": "Path 107988",
    d: "M61.895,46.743l-6.722-3.767v11.3l6.722-3.811h.042l.729-.429,2.525-1.413Z",
    transform: "translate(28.089 21.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107989",
    "data-name": "Path 107989",
    d: "M88.8,40.64a21.512,21.512,0,0,0-31.24-28.27c.024.059.032.124.054.184a4.841,4.841,0,0,1,.187.622,7.876,7.876,0,0,1,.684,2.052v0A18.663,18.663,0,1,1,55.2,40.635a7.047,7.047,0,0,1-.549.877l-.008.009a6.608,6.608,0,0,1-.564.653,6.868,6.868,0,0,1-.611.954,21.411,21.411,0,0,0,27.412,5.3l8.391,2.867a1.81,1.81,0,0,0,2.309-2.264Z",
    transform: "translate(27.219 4.187)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107990",
    "data-name": "Path 107990",
    d: "M66.781,25.866,58.348,17.3a.864.864,0,0,1-.172-.942c1.541-3.9,4.281-5.137,8.348-3.682a.92.92,0,0,1,.6.813V25.738a.2.2,0,0,1-.343.128",
    transform: "translate(29.582 6.156)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107991",
    "data-name": "Path 107991",
    d: "M65,25.736l-.042-12.029a.909.909,0,0,1,.513-.813c3.811-1.713,6.678-.685,8.561,3.21a.845.845,0,0,1-.171.985L65.3,25.822c-.128.171-.3.085-.3-.086",
    transform: "translate(33.073 6.157)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107992",
    "data-name": "Path 107992",
    d: "M65.8,24.909l8.433-8.561a.86.86,0,0,1,.942-.214c3.9,1.455,5.223,4.2,3.811,8.3a.875.875,0,0,1-.813.6l-12.243.214a.2.2,0,0,1-.128-.343",
    transform: "translate(33.47 8.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107993",
    "data-name": "Path 107993",
    d: "M66.307,24.887l-8.689-8.6a.887.887,0,0,0-.261-.168,8.466,8.466,0,0,1,.051,1.189c.032.107.089.2.115.309a11.8,11.8,0,0,1,.32,2.627,7.572,7.572,0,0,1-.1,1.179,5.839,5.839,0,0,1,.1,1.307,2.6,2.6,0,0,1-.009.266c-.066.688-.143,1.376-.275,2.054-.008.038-.018.074-.027.11l8.689.032c.172,0,.214-.172.086-.3",
    transform: "translate(29.201 8.204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107994",
    "data-name": "Path 107994",
    d: "M66.781,23.926l-8.433,8.561a.864.864,0,0,0-.172.942c1.541,3.9,4.281,5.137,8.348,3.682a.92.92,0,0,0,.6-.813V24.054c0-.128-.214-.214-.343-.128",
    transform: "translate(29.582 12.163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107995",
    "data-name": "Path 107995",
    d: "M65,24.05,64.961,36.08a.909.909,0,0,0,.513.813c3.811,1.713,6.678.685,8.561-3.21a.845.845,0,0,0-.171-.985L65.3,23.964a.168.168,0,0,0-.3.086",
    transform: "translate(33.073 12.168)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107996",
    "data-name": "Path 107996",
    d: "M65.8,23.321l8.433,8.561a.86.86,0,0,0,.942.214c3.9-1.455,5.223-4.2,3.811-8.3a.875.875,0,0,0-.813-.6l-12.243-.214c-.171.042-.257.257-.128.343",
    transform: "translate(33.47 11.698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107997",
    "data-name": "Path 107997",
    d: "M67.329,23.035l-9.16.033c-.012.048-.026.1-.038.146a.655.655,0,0,1-.024.094c-.006.017-.012.033-.02.05q-.156.369-.312.739l-.14,1.055-.006.024a7.388,7.388,0,0,1-.634,1.55,5.494,5.494,0,0,1-.448,1.177,5.353,5.353,0,0,1-.9,1.621,6.717,6.717,0,0,1-.466.785,8.222,8.222,0,0,0,2.561,1.8.845.845,0,0,0,.984-.172l8.691-8.6c.128-.128.085-.3-.086-.3",
    transform: "translate(28.092 11.727)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107998",
    "data-name": "Path 107998",
    d: "M48.87,0A28.8,28.8,0,0,0,23.864,43.025L20.015,54.283a2.412,2.412,0,0,0,3.033,3.079l11.258-3.728A28.788,28.788,0,1,0,48.87,0m.091,53.724A24.961,24.961,0,1,1,73.906,28.764,24.951,24.951,0,0,1,48.96,53.724",
    transform: "translate(10.122 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107999",
    "data-name": "Path 107999",
    d: "M57.9,21.69a1.142,1.142,0,0,1-1.117.785h-.936a5.033,5.033,0,0,0-9.93,0h-3.35a4.686,4.686,0,0,0-.755-1.992l9.885-9.7a1.181,1.181,0,0,1,1.283-.257c5.176,2.052,6.9,5.735,4.92,11.167",
    transform: "translate(21.29 5.314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108000",
    "data-name": "Path 108000",
    d: "M53.231,31.708A1.151,1.151,0,0,1,51.9,31.5L41.837,21.657a5.023,5.023,0,0,0,.739-2.007l3.32-.015a5.026,5.026,0,0,0,9.96-.03h.589a1.147,1.147,0,0,1,1.071.679c2.264,5.1.936,8.9-4.286,11.424",
    transform: "translate(21.3 9.981)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108001",
    "data-name": "Path 108001",
    d: "M51.635,32.62c-1.977,5.222-5.614,6.972-11.092,5.131a1.2,1.2,0,0,1-.815-1.117L39.517,22.75a4.712,4.712,0,0,0,2.218-.875l9.643,9.492a1.172,1.172,0,0,1,.257,1.253",
    transform: "translate(20.119 11.137)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108002",
    "data-name": "Path 108002",
    d: "M51.514,11.973l-9.779,9.885a4.645,4.645,0,0,0-2.158-.875l.03-13.642a1.178,1.178,0,0,1,.739-1.071c5.086-2.218,8.9-.845,11.379,4.376a1.176,1.176,0,0,1-.211,1.328",
    transform: "translate(20.149 2.672)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108003",
    "data-name": "Path 108003",
    d: "M31.918,10.78l10.036,9.839a4.833,4.833,0,0,0-.694,1.856H37.91a5.024,5.024,0,0,0-9.915,0H26.833a1.156,1.156,0,0,1-1.117-.785c-1.977-5.433-.257-9.115,4.92-11.167a1.176,1.176,0,0,1,1.283.257",
    transform: "translate(12.686 5.315)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108004",
    "data-name": "Path 108004",
    d: "M41.855,21.522,31.669,31.5a1.151,1.151,0,0,1-1.328.211c-5.222-2.52-6.55-6.323-4.286-11.424a1.147,1.147,0,0,1,1.071-.679h.815a5.018,5.018,0,0,0,9.945.03l3.32.015a4.934,4.934,0,0,0,.649,1.871",
    transform: "translate(12.725 9.981)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108005",
    "data-name": "Path 108005",
    d: "M40.395,21.815a4.775,4.775,0,0,0,2.128.936l-.211,13.914a1.2,1.2,0,0,1-.815,1.117c-5.478,1.841-9.115.091-11.092-5.131a1.172,1.172,0,0,1,.257-1.253Z",
    transform: "translate(15.438 11.106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108006",
    "data-name": "Path 108006",
    d: "M42.515,21.013a4.583,4.583,0,0,0-2.083.921l-9.855-9.96a1.176,1.176,0,0,1-.211-1.328c2.475-5.222,6.293-6.595,11.379-4.376a1.178,1.178,0,0,1,.739,1.071Z",
    transform: "translate(15.4 2.672)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeylimeBlack);
export default __webpack_public_path__ + "static/media/heylime-black.6f2456d2f94191bfe498bac503b058f2.svg";
export { ForwardRef as ReactComponent };